import { FC, ReactNode } from "react";
import ButtonIcon from "@/components/UI/Buttons/ButtonIcon";
import useIsMobile from "@/custom_hooks/isMobile";
import letterImg from "@/assets/images/newsletter/newsletter.svg";
import background from "@/assets/images/newsletter/gradient-newsl-bg.png";

type Props = {
  handleSubmit: React.FormEventHandler<HTMLFormElement>;
  isLoading: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  name: string;
  email: string;
  successMsg?: string;
  errorMsg?: string;
  checkbox: ReactNode;
};

const StandardNewsletterForm: FC<Props> = ({
  handleSubmit,
  onChange,
  isLoading,
  name,
  email,
  successMsg,
  errorMsg,
  checkbox,
}) => {
  const isMobile = useIsMobile();

  return (
    <div className="bg-grey-200 border-stroke relative grid gap-4 overflow-hidden rounded-[22px] border-[1px] px-4 py-10 md:grid-cols-2 md:pt-[50px] md:pb-[20px] md:pl-[93px]">
      <img src={background} className="absolute right-0 h-full" />
      <div className="z-1 flex flex-col">
        <h2 className="text-grey md:text-primary">
          Prisijunkite prie ilgaamžiškumo bendruomenės
        </h2>

        {isMobile && (
          <img
            src={letterImg}
            alt="Newsletter"
            className="w-full pt-8 md:hidden"
          />
        )}

        <div className="mt-8">
          <form onSubmit={handleSubmit}>
            <div className="flex flex-col pb-6">
              <div className="mb-8 flex flex-col gap-2">
                <label className="md:text-lg" htmlFor="full_name">
                  Vardas ir pavardė*
                </label>
                <input
                  className="bg-sand shadow-grey-400 md:shadow-stroke inline-flex h-[53px] w-full items-center justify-center rounded-[10px] px-[10px] text-[18px] leading-none shadow-[0_0_0_1px] outline-none focus:shadow-[0_0_0_2px]"
                  id="full_name"
                  disabled={isLoading}
                  name="full_name"
                  value={name}
                  onChange={onChange}
                />
              </div>

              <div className="flex flex-col gap-2">
                <label className="md:text-lg" htmlFor="email">
                  El. paštas*
                </label>
                <input
                  className="bg-sand shadow-grey-400 md:shadow-stroke inline-flex h-[53px] w-full items-center justify-center rounded-[10px] px-[10px] text-[18px] leading-none shadow-[0_0_0_1px] outline-none focus:shadow-[0_0_0_2px]"
                  id="email"
                  disabled={isLoading}
                  name="email"
                  value={email}
                  onChange={onChange}
                />
              </div>
              {checkbox}
            </div>

            <div className="flex justify-center">
              {successMsg && !errorMsg && (
                <p className="text-green-700">{successMsg}</p>
              )}
              {errorMsg && !successMsg && (
                <p className="text-red-700">{errorMsg}</p>
              )}
            </div>

            <div className="flex w-full justify-center py-6">
              <ButtonIcon
                disabled={isLoading}
                submitType={true}
                iconWidth={isMobile ? 19 : 24}
                iconHeight={isMobile ? 19 : 24}
                label="Prenumeruokite naujienlaiškį"
                icon="email"
                theme="dark"
              />
            </div>
          </form>
        </div>
      </div>
      <Image />
    </div>
  );
};

export default StandardNewsletterForm;

const Image = () => (
  <div className="relative flex hidden content-center justify-end md:block">
    <img src={letterImg} className="w-full" />
  </div>
);
